export default 'Coup de pouce CVC tertiaire : bonification des primes CEE BAT-TH sur chauffage, ventilation et climatisation. Éligibilité et estimation avec Solution Éco France.';
